import { useQuery } from 'react-query';

import { getCardResourceInit as queryFn } from 'api/endPoints/getCardResourceInit';
import { IVersion } from 'api/queries/getProjectVersionsList.query';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetCardResourceInit = (params: QueryParams) => {
    return useQuery<ICardResourceInit[], QueryError, ICardResourceInit[], [QueryKeys, unknown]>({
        queryKey: ['getCardResourceInit', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.metaDataId),
    });
};

export interface QueryParams {
    metaDataId?: IVersion['id'];
}

export interface ICardResourceInit {
    count: number;
    label: string;
    value: number;
}
